export class FetchResult<T>{

    totalRows: number;
    startRow: number;
    endRow: number;
    rowsPage: number;
    fetchedList: Array<T>

    param01: string;
    param02: string;
    param03: string;
    param04: string;
    param05: number;
    bean: T;
    param5: string;
    busqueda: any[];
}